export default __webpack_public_path__ + "static/media/marketing.ddb9a5b3.png";